module.exports = __webpack_public_path__ + "img/yuqi.89ab3559.png";